<div class="row">
  <div class="col">
    <kendo-label [text]="labelName" class="input-label-header" [for]="formGroup"></kendo-label>
  </div>
</div>
<hr class="input-label-header-hr" />
<div class="row">
  <div class="col">
    <form [formGroup]="formGroup">
      <div *ngFor="let inputOption of indication.inputOptions">
        <kendo-label class="k-form" [text]="getInputLabel(inputOption, indication['units'])" style="color: #92929f;">
          <kendo-textbox
            [style.width.px]="200"
            [formControlName]="inputOption.name"
            placeholder=""
            [clearButton]="true"
            (valueChange)="updateSelections()"
            [maxlength]="inputOption.maxlength"
            [minlength]="1"
          >
          </kendo-textbox>
        </kendo-label>
      </div>
    </form>
    <button *ngIf="!hasCustomControlParent" kendoButton (click)="setDefaults()">Set Default Values</button>
  </div>
</div>